import React, { forwardRef } from "react";

import UIcon from "../../../lib/icons/untitled_ui/UIcon";
import Button, { ButtonProps } from "../button/Button";
import TooltipComponent, { TooltipComponentProps } from "../tooltip/Tooltip";

type ButtonDropdownMenuProps = ButtonProps<"button"> & {
  hideArrow?: boolean;
  tooltip?: Omit<TooltipComponentProps, "children">;
};

const DropdownMenuTrigger = forwardRef<HTMLButtonElement, ButtonDropdownMenuProps>((props, ref) => {
  const { children, hideArrow = false, tooltip, ...rest } = props;

  const buttonContent = (
    <Button
      as="button"
      ref={ref}
      {...rest}
      buttonStyle={props.buttonStyle || "default"}
      buttonType={props.buttonType || "secondary"}
    >
      {children}
      {hideArrow !== true && <UIcon icon="chevronDown" {...props.iconProps} className="chevron" />}
    </Button>
  );

  if (tooltip) {
    return <TooltipComponent {...tooltip}>{buttonContent}</TooltipComponent>;
  }

  return buttonContent;
});

DropdownMenuTrigger.displayName = "DropdownMenuTrigger";

export default DropdownMenuTrigger;
